
import { defineComponent, onMounted, ref } from 'vue'

//services
import pservice from '@/core/services/PublicService';
import { useRoute } from 'vue-router';

export default defineComponent({
    name: "public-sport-fixture",
    setup() {
        const loading = ref(false)
        const route = useRoute();
        const { idevent, idsport } = route.params
        const listGroups = ref<any>([])
        const listFixture = ref<any>([])

        const rowsFixture = ref<any>([])
        //const fechas = ref<any>([])

        const getMore = async () => {
            loading.value = true
            await pservice.more({
                evento: idevent,
                sport: idsport
            })
                .then((res) => {
                    loading.value = false
                    if (res.data) {
                        let info = res.data
                        Groups(info.event.idevent, info.sport.idsport)
                        Fixture(info.event.idevent, info.sport.idsport)
                    }
                }).catch(({ response }) => { loading.value = false })
        }

        const Groups = async (a: any, b: any) => {
            loading.value = true
            await pservice.getGroups(`idevent=${a}&idsport=${b}`)
                .then((res) => {
                    loading.value = false
                    listGroups.value = res.data
                }).catch(({ response }) => { loading.value = false })
        }

        const Fixture = async (a: any, b: any) => {
            //loading.value = true
            await pservice.getFixture(`idevent=${a}&idsport=${b}`)
                .then((res) => {
                    //loading.value = false
                    listFixture.value = res.data

                    /*const valores = new Set<string>();
                    listFixture.value.forEach(item => {
                        valores.add(item.groupAsciiLetter);
                    });
                    itemsGroup.value = Array.from(valores);

                    itemsGroup.value.forEach(element => {

                    });*/


                    /*const gruposUnicos = new Map<string, { group: string, fechas: { dateOrder: number }[] }>();

                    listFixture.value.forEach(item => {
                        const { groupAsciiLetter, dateOrder } = item;

                        if (!gruposUnicos.has(groupAsciiLetter)) {
                        gruposUnicos.set(groupAsciiLetter, { group: groupAsciiLetter, fechas: [] });
                        }

                        const grupo = gruposUnicos.get(groupAsciiLetter);

                        if (!grupo?.fechas.some(fecha => fecha.dateOrder === dateOrder)) {
                        grupo?.fechas.push({ dateOrder });
                        }
                    });

                    console.log(Array.from(gruposUnicos.values()));
                    */

                    const gruposUnicos = new Map<string, { group: string, fechas: { dateOrder: number, informacion: any[] }[] }>();

                    listFixture.value.forEach(item => {
                        const { groupAsciiLetter, dateOrder, ...resto } = item;

                        if (!gruposUnicos.has(groupAsciiLetter)) {
                            gruposUnicos.set(groupAsciiLetter, { group: groupAsciiLetter, fechas: [] });
                        }

                        const grupo = gruposUnicos.get(groupAsciiLetter);

                        let fechaIndex = -1;
                        grupo?.fechas.forEach((fecha, index) => {
                            if (fecha.dateOrder === dateOrder) {
                                fechaIndex = index;
                            }
                        });

                        if (fechaIndex === -1) {
                            grupo?.fechas.push({ dateOrder, informacion: [resto] });
                        } else {
                            grupo?.fechas[fechaIndex].informacion.push(resto);
                        }
                    });

                    rowsFixture.value = Array.from(gruposUnicos.values());




                }).catch(({ response }) => { })
        }



        onMounted(() => {
            getMore()
        })

        return {
            loading,
            listGroups,
            rowsFixture,
            listFixture,
            Groups

        }

    },
})
